import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import cellEditFactory from 'react-bootstrap-table2-editor';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTrash
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faTrash)

const OffenceTable = ({
    offences,
    onUpdateAttribute,
    onOffenceDelete
}) => {
    const { byid, list } = offences

    let data = []
    list.forEach((id) => {
        let offence = byid[id]
        let item = {}
        item['id'] = id
        item['code'] = offence.code
        item['description'] = offence.description
        data.push(item)
    })

    let columns = [
        {
            dataField: 'id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true,
            editable: false
        },
        {
            dataField: 'code',
            text: 'Code',
            headerClasses: "table-col-head text-center",
            align: 'center',
            sort: true,
            headerStyle: () => {
                return { width: '20%' };
            },
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'description',
            text: 'Description',
            headerClasses: "table-col-head",
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'action',
            text: 'Action',
            headerClasses: "table-col-head",
            align: 'center',
            editable: false,
            // eslint-disable-next-line react/display-name
            formatter: () => {
                return (
                    <div className="text-center" style={{ cursor: 'hand' }}>
                        <label>
                            <FontAwesomeIcon style={{ cursor: 'hand' }} color='red' icon='trash'></FontAwesomeIcon>
                        </label>
                    </div>
                )
            },
            events: {
                onClick: (e, columns, columnIndex, row) => {
                    onOffenceDelete(byid[row.id])
                }
            },
            headerStyle: () => {
                return { width: '20%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        }
    ];

    return (
        <React.Fragment>
            <BootstrapTable
                classes="table-md table-responsive-sm align-middle"
                keyField='id'
                data={data}
                columns={columns}
                striped
                condensed
                bordered={false}
                noDataIndication="Record not found"
                cellEdit={cellEditFactory({
                    mode: 'click',
                    afterSaveCell: (oldValue, newValue) => {
                        if (oldValue === newValue) {
                            return;
                        }
                    }
                })}
            />
        </React.Fragment>
    )
};

OffenceTable.propTypes = {
    offences: PropTypes.object,
    onUpdateAttribute: PropTypes.func,
    onOffenceDelete: PropTypes.func
};

export default OffenceTable;



// WEBPACK FOOTER //
// ./src/components/blocks/OffenceTable/OffenceTable.js